import DoctorSelectPage from './DoctorSelectPage'
export default DoctorSelectPage
